var emitFormHeightMessage = function emitFormHeightMessage(formLoaded, formHeightInfo) {
  if (!formLoaded || !formHeightInfo) return;

  try {
    var location = window.location.toString();
    var contentRect = formHeightInfo.contentRect,
        target = formHeightInfo.target;
    var height = target && target.scrollHeight;
    if (!height) height = contentRect.height || target.clientHeight;
    window.parent && window.parent.postMessage(['setHeight', height, location], '*');
  } catch (_unused) {}
};

export default {
  emitFormHeightMessage: emitFormHeightMessage
};